import styled from 'styled-components';
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "sc-175s3ha-0"
})(["position:relative;border-radius:10%;height:55px;width:100%;"]);
export var Button = styled.button.withConfig({
  displayName: "style__Button",
  componentId: "sc-175s3ha-1"
})(["height:35px;min-height:30px;max-height:55px;padding-left:5px;padding-right:0;background:#eee;border-radius:18px;color:#111;padding-top:5px;position:relative;width:100%;box-sizing:border-box;border:none;vertical-align:top;white-space:nowrap;text-align:center;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;text-transform:none;font-weight:500;outline:none;overflow:hidden;margin:auto;&:focus{outline:0;}", ":hover &{border:none;cursor:", ";background:rgba(0,0,0,0.15);}"], ButtonContainer, function (props) {
  return props.active ? 'pointer' : 'wait';
});